import LearningObjectDetails from "./LearningObjectDetails";

export default LearningObjectDetails;
